module.exports = __webpack_public_path__ + "img/2000_5e33d3cd3eb25.09af4a29.png";